export function normalizeStatusKey(value) {
  return String(value).toLowerCase().replace(/[\s-]+/g, '_');
}

export function getOrderStatusColors(status, isDarkMode) {
  const key = normalizeStatusKey(status);
  if (key.includes('cancel') || key.includes('fail') || key.includes('reject')) {
    return {
      bgcolor: isDarkMode ? 'rgba(198, 40, 40, 0.22)' : '#FFEBEE',
      color: isDarkMode ? '#EF9A9A' : '#C62828',
    };
  }
  if (key.includes('complete') || key.includes('deliver') || key.includes('done') || key.includes('approv')) {
    return {
      bgcolor: isDarkMode ? 'rgba(46, 125, 50, 0.22)' : '#E8F5E9',
      color: isDarkMode ? '#A5D6A7' : '#2E7D32',
    };
  }
  if (key.includes('pending') || key.includes('process') || key.includes('new') || key.includes('confirm')) {
    return {
      bgcolor: isDarkMode ? 'rgba(245, 127, 23, 0.22)' : '#FFF8E1',
      color: isDarkMode ? '#FFCC80' : '#F57F17',
    };
  }
  return {
    bgcolor: isDarkMode ? 'rgba(184, 137, 74, 0.18)' : 'rgba(184, 137, 74, 0.12)',
    color: isDarkMode ? '#D4A574' : '#B8894A',
  };
}

export function translateOrderStatus(status, t) {
  if (!status) return t('orders_status_unknown');
  const key = normalizeStatusKey(status);
  return t(`orders_status_${key}`, { defaultValue: status });
}

export function translateDeliveryType(deliveryType, t) {
  if (!deliveryType) return '';
  const key = normalizeStatusKey(deliveryType);
  return t(`orders_delivery_${key}`, { defaultValue: deliveryType.replace(/_/g, ' ') });
}

export function formatOrderDate(value, locale) {
  if (!value) return '';
  const parsed = new Date(value);
  if (!Number.isNaN(parsed.getTime())) {
    const dateLocale = locale === 'ku' ? 'ckb-IQ' : 'ar-IQ';
    return parsed.toLocaleDateString(dateLocale, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  }
  return String(value);
}

export function formatOrderTotal(value) {
  if (value == null || value === '') return '';
  const num = Number(value);
  if (Number.isNaN(num)) return String(value);
  return num.toLocaleString();
}

export function hasOrderMoney(value) {
  if (value == null || value === '') return false;
  return Number.isFinite(Number(value));
}
